import { info } from 'next/dist/build/output/log';
import { useRouter } from 'next/router';
import usePrevious from 'react-use/lib/usePrevious';

export function useNavigatableInitialData<D>(props: D): D {
  // TODO research for a nextjs-based solution like Router.events.on('routeChangeStart', () => ... );
  const { query, pathname } = useRouter();
  const prevQuery = usePrevious(query);
  const prevPathname = usePrevious(pathname);

  if (prevQuery && query !== prevQuery && prevPathname === pathname) {
    info('Navigation occurred, clearing fallbackData');
    return undefined;
  } else {
    return props;
  }
}
